module.exports = __webpack_public_path__ + "47b3af4308a71b7e6ef32d9e4d5ce204.png";